import React from "react";

const Footer = () => {
  return (
    <footer className="bg-white fixed right-0 bottom-0">
      <span className="text-sm text-gray-500">
        © 2025{" "}SilverLine™
        . All Rights Reserved.
      </span>
    </footer>
  );
};

export default Footer;
